<template>
  <v-container fluid grid-list-md style="padding: 20px;">
    <v-row>
      <v-col cols="12" sm="12" md="6" v-if="user.tipo == 'ADMIN'">
        <v-select
          outlined
          dense
          v-model="empresaSelecionada"
          :items="empresas"
          item-text="nome"
          item-value="id"
          label="Selecione a empresa"
          @input="carregaAlunos(empresaSelecionada)"
        ></v-select>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <v-data-table
          :search="tabela.busca"
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          sort-by="titulo"
          class="elevation-1"
          style="border-radius: 10px;"
          :footer-props="{
            'items-per-page-text': 'Linhas por página',
            'items-per-page-all-text': 'Tudo',
          }"
          :loading="tabela.carregamento"
          loading-text="Buscando itens..."
        >
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">ALUNOS</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field v-model="tabela.busca" append-icon="search" label="Procurar" single-line hide-details></v-text-field>
              <v-spacer></v-spacer>
              <v-btn text @click="dialogoAluno = true" tile color="#3BA8A2" :disabled="user.tipo == 'ADMIN' ? empresaSelecionada == '' : false">
                <v-icon left dark>add_circle</v-icon>Cadastrar
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="editItem(item)" color="#01579B">mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom v-if="user.tipo == 'ADMIN'">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="deleteItem(item)" color="#FF0000">mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.sexo`]="{ item }">
            <p v-if="item.sexo == 'MASCULINO'" style="margin: 0px">Masculino</p>
            <p v-if="item.sexo == 'FEMININO'" style="margin: 0px">Feminino</p>
            <p v-if="item.sexo == 'NÃO BINÁRIO'" style="margin: 0px">Não Binário</p>
          </template>
          <template v-slot:[`item.dataNascimento`]="{ item }">
            <p style="margin: 0px" v-if="item.dataNascimento">{{ item.dataNascimento }}, {{ calculaIdade(item.dataNascimento) }} anos</p>
          </template>
          <template v-slot:no-data>
            <v-row style="margin: 0px">
              <v-col>
                <v-alert v-if="user.tipo == 'ADMIN' && empresaSelecionada == ''" dark dense text outlined color="info" icon="info" style="margin: 0px">Selecione uma empresa para visualizar os usuários</v-alert>
                <v-alert v-if="empresaSelecionada" dark dense text outlined color="warning" icon="info" style="margin: 0px">Nenhum aluno cadastrado</v-alert>
                <v-alert v-if="user.tipo != 'ADMIN'" dark dense text outlined color="warning" icon="info" style="margin: 0px">Nenhum aluno cadastrado</v-alert>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogoAluno" persistent max-width="500px" scrollable>
      <v-card>
        <v-card-title>{{ formTitle }}</v-card-title>
        <v-card-text style="padding-bottom: 0px; padding-top: 10px">
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field
                label="Nome*"
                outlined
                dense
                hide-details
                v-model="editedItem.nome"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="6">
              <v-text-field
                label="CPF*"
                outlined
                dense
                hide-details
                v-model="editedItem.cpf"
                v-mask="'###.###.###-##'"
                type="tel"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="6">
              <v-select
                label="Sexo*"
                outlined
                dense
                hide-details
                v-model="editedItem.sexo"
                :items="sexos"
                item-text="text"
                item-value="value"
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="6">
              <v-text-field
                label="WhatsApp*"
                outlined
                dense
                hide-details
                v-model="editedItem.whatsapp"
                v-mask="'(##) #####-####'"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" lg="6">
              <v-text-field
                label="Data de Nascimento*"
                outlined
                dense
                hide-details
                v-model="editedItem.dataNascimento"
                v-mask="'##/##/####'"
                type="tel"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-card outlined>
                <v-card-title style="padding: 10px 16px 10px 16px">Foto</v-card-title>
                <v-card-text style="padding: 0px">
                  <v-img
                    v-if="editedItem.foto"
                    :src="editedItem.foto"
                    contain
                    width="100%"
                    height="100%"
                  ></v-img>
                  <v-alert
                    v-if="!editedItem.foto"
                    type="info"
                    style="margin: 0px"
                  >
                    <p>Nenhuma foto</p>
                    <v-btn outlined @click="dialogoCamera = true">Capturar Foto</v-btn>
                    <br>
                    <file-upload
                      class="btn btn-primary mt-1"
                      input-id="file1"
                      extensions="png,gif,jpeg,jpg"
                      accept="image/png,image/gif,image/jpeg,image/jpg"
                      post-action="/upload/post"
                      v-model="filesRg1"
                      @input-filter="inputFilter"
                      @input-file="inputFileRg1"
                      ref="upload1"
                    >
                      <v-btn outlined>Selecionar Foto</v-btn>
                      <p id="foto" value="" hidden></p>
                    </file-upload>
                  </v-alert>
                </v-card-text>
                <v-card-actions v-if="editedItem.foto && editedIndex == -1">
                  <v-row dense>
                    <v-col cols="12">
                      <v-btn text @click="dialogoCamera = true" color="primary">Capturar Outra</v-btn>
                    </v-col>
                    <v-col cols="12">
                      <file-upload
                        class="btn btn-primary"
                        input-id="file1"
                        extensions="png,gif,jpeg,jpg"
                        accept="image/png,image/gif,image/jpeg,image/jpg"
                        post-action="/upload/post"
                        v-model="filesRg1"
                        @input-filter="inputFilter"
                        @input-file="inputFileRg1"
                        ref="upload1"
                      >
                        <v-btn color="primary" text>Selecionar Outra</v-btn>
                        <p id="foto" value="" hidden></p>
                      </file-upload>
                    </v-col>
                    <v-col cols="12">
                      <v-btn color="error" @click="editedItem.foto = ''" text>Remover</v-btn>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="dialogoAluno = false">Fechar</v-btn>
          <v-btn text color="success" @click="salvarUsuario" v-if="editedIndex == -1">Salvar</v-btn>
          <v-btn text color="success" @click="editarUsuario" v-if="editedIndex != -1">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogoCamera" max-width="500px">
      <v-card>
        <v-card-title style="padding: 5px 15px 5px 15px">
          Câmera
          <v-spacer></v-spacer>
          <v-btn @click="dialogoCamera = false" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="padding: 0px">
          <WebCam
            ref="webcam"
            :deviceId="deviceId"
            width="100%"
            height="100%"
            :isFrontCam="frontCam"
            :googleKey="googleKey"
          ></WebCam>
          <div align="center" justify="center" style="padding-bottom: 8px">
            <v-btn @click="capturarFoto" fab dark>
              <v-icon large>mdi-camera-iris</v-icon>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <Snackbar ref=chamaSnackbar />
    <loading :active.sync="isLoading" :can-cancel="true" color="#3BA8A2" :is-full-page="fullPage"></loading>
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import { WebCam } from 'vue-cam-vision'
  import CpfValidate from '../componentes/validators/rules/cpf'
  import FileUpload from 'vue-upload-component'
  export default {
    components: { Snackbar, Loading, WebCam, FileUpload },
    data: () => ({
      isLoading: false,
      fullPage: true,
      empresas: [],
      empresaSelecionada: '',
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Nome', align: 'start', value: 'nome', },
          { text: 'CPF', value: 'cpf' },
          { text: 'Sexo', value: 'sexo' },
          { text: 'Data de Nascimento', value: 'dataNascimento' },
          { text: 'WhatsApp', value: 'whatsapp' },
          { text: 'Ações', value: 'action', sortable: false },
        ],
        carregamento: false,
        conteudo: [],
      },
      sexos: [
        { text: 'Masculino', value: 'MASCULINO' },
        { text: 'Feminino', value: 'FEMININO' },
      ],
      dialogoAluno: false,
      editedIndex: -1,
      editedItem: {
        nome: '',
        sexo: '',
        whatsapp: '',
        cpf: '',
        foto: '',
        empresaId: '',
        dataNascimento: '',
      },
      defaultItem: {
        nome: '',
        sexo: '',
        whatsapp: '',
        cpf: '',
        foto: '',
        empresaId: '',
        dataNascimento: '',
      },
      dialogoCamera: false,
      deviceId: null,
      frontCam: null,
      googleKey: null,
      filesRg1: [],
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle () {
        return this.editedIndex === -1 ? 'Adicionar novo aluno' : 'Editar aluno'
      },
    }),

    watch: {
      dialogoAluno(val) {
        if (val == false) {
          setTimeout(() => {
            this.editedIndex = -1
            this.editedItem = Object.assign({}, this.defaultItem)
          }, 300);
        }
      },

      dialogoCamera(val) {
        if (val == true) {
          this.$refs.webcam.start()
        } else {
          this.$refs.webcam.stop()
        }
      },

      empresas() {
        this.empresaSelecionada = this.empresas[0].id
        this.carregaAlunos(this.empresaSelecionada)
      },
    },

    mounted() {
      if (this.user.tipo == 'ADMIN') {
        this.carregaEmpresas()
      } else {
        this.carregaAlunos(this.companyobj.id)
      }
    },

    beforeDestroy() {
      this.$refs.webcam.stop()
    },

    methods: {
      async carregaEmpresas() {
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data
          }
        })
      },

      async carregaAlunos(id) {
        this.tabela.conteudo = []
        this.isLoading = true
        this.tabela.carregamento = true
        await axios.get(baseApiUrl + 'Alunos?filter={"where":{"empresaId":"' + id + '"}, "order": "nome ASC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.tabela.conteudo = response.data
            this.tabela.carregamento = false
          }
          this.isLoading = false
        })
      },

      editItem (item) {
        this.isLoading = true
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogoAluno = true
        this.isLoading = false
      },

      async salvarUsuario() {
        var vm = this;
        if (!this.editedItem.nome || !this.editedItem.sexo || !this.editedItem.whatsapp || !this.editedItem.cpf || !this.editedItem.foto || !this.editedItem.dataNascimento) {
          vm.$refs.chamaSnackbar.snack("orange", "Preencha todos os campos para prosseguir", "ATENÇÃO")
        } else if (!CpfValidate(this.editedItem.cpf)) {
          vm.$refs.chamaSnackbar.snack("orange", "CPF informado não é válido", "ATENÇÃO")
        } else {
          this.isLoading = true
          this.editedItem.empresaId = this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id
          this.editedItem.nome = this.editedItem.nome.toUpperCase()
          await axios.post(baseApiUrl + 'Alunos/novoAluno?access_token=' + sessionStorage.getItem('accToken'), this.editedItem)
          .then(response => {
            if (response.data) {
              if (response.data.mensagem.includes('com sucesso')) {
                this.dialogoAluno = false
                vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
                this.carregaAlunos(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id)
              } else if (response.data.mensagem.includes('Já existe um aluno')) {
                vm.$refs.chamaSnackbar.snack("orange", "Desculpe, já existe um aluno com os mesmos dados informados", "ATENÇÃO")
              }
              this.isLoading = false
            }           	
          })
          .catch(() => {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#FF0000", "Problema ao realizar operação, tente novamente", "DESCULPE")
          })
        }
      },

      async editarUsuario() {
        var vm = this;
        if (!this.editedItem.nome || !this.editedItem.sexo || !this.editedItem.whatsapp || !this.editedItem.cpf || !this.editedItem.foto || !this.editedItem.dataNascimento) {
          vm.$refs.chamaSnackbar.snack("orange", "Preencha os campos para prosseguir", "ATENÇÃO")
        } else if (!CpfValidate(this.editedItem.cpf)) {
          vm.$refs.chamaSnackbar.snack("orange", "CPF informado não é válido", "ATENÇÃO")
        } else {
          this.isLoading = true
          this.editedItem.nome = this.editedItem.nome.toUpperCase()
          await axios.put(baseApiUrl + 'Alunos/' + this.editedItem.id + '?access_token=' + sessionStorage.getItem('accToken'), this.editedItem)
          .then(response => {
            if (response.data) {
              this.isLoading = false
              this.dialogoAluno = false
              vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
              this.carregaAlunos(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id)
            }           	
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("red", "Erro ao realizar operação", "#BF4554")
          })
        }
      },

      async deleteItem(item) {
        var vm = this;
        var r = confirm('Realmente deseja EXCLUIR o(a) aluno(a) ' + item.nome + '?')

        if (r == true) {
          this.isLoading = true
          let faceExcluida = await this.excluirFace(item.faceId)

          if (faceExcluida == true) {
            await axios.delete(baseApiUrl + 'Alunos/' + item.id + '?access_token=' + sessionStorage.getItem('accToken'))
            .then(() => {
              vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
              this.carregaAlunos(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id)
              this.isLoading = false
            })
          } else {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("red", "Problema ao realizar operação", "DESCULPE")
          }
        }
      },

      async excluirFace(faceId) {
        let result

        await axios.post(baseApiUrl + 'Faces/deletarImagemNaColecao', {"faceId": faceId})
        .then(response => {
          if (response.data.mensagem.includes('sucesso')) {
            result = true
          }
          else {
            result = false
          }
        })
        .catch(() => {
          result = false
        })

        return result
      },

      async capturarFoto() {
        this.editedItem.foto = await this.$refs.webcam.capture()
        this.dialogoCamera = false
      },

      calculaIdade(dataNasc) {
        let dataAtual = new Date();
        let anoAtual = dataAtual.getFullYear();
        let anoNascParts = dataNasc.split('/');
        let diaNasc = anoNascParts[0];
        let mesNasc = anoNascParts[1];
        let anoNasc = anoNascParts[2];
        let idade = anoAtual - anoNasc;
        let mesAtual = dataAtual.getMonth() + 1;
        // Caso mês atual for menor que o de nascimento, não fez aniversário ainda;
        if (mesAtual < mesNasc) {
          idade--;
        } else {
          // Estando no mês do nascimento, verifica o dia
          if (mesAtual == mesNasc) {
            if (new Date().getDate() < diaNasc ) {
              // Caso a data atual for menor que o dia de nascimento, ainda não fez aniversário
              idade--;
            }
          }
        }
        return idade;
      },

      inputFilter(newFile, oldFile, prevent) {
        if (newFile && !oldFile) {
          // Before adding a file
          // Filter system files or hide files
          if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
            return prevent()
          }
          // Filter php html js file
          if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
            return prevent()
          }
        }
      },

      inputFileRg1(newFile, oldFile) {
        if (newFile && !oldFile) {
          var reader = new FileReader()
          var file = this.filesRg1[0]

          //salva a base64 na variável
          reader.onloadend = function() {
            document.getElementById('foto').value = reader.result
          };

          setTimeout(() => {
            this.editedItem.foto = document.getElementById('foto').value
          }, 500);

          //Gera base64
          reader.readAsDataURL(file.file);
        }

        if (newFile && oldFile) {
          // update
        }

        if (!newFile && oldFile) {
          // remove
        }
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #424f4e;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }
  
  span.v-stepper__step__step.primary {
    background-color: #009B99!important;
    border-color: #009b9b!important;
  }

  .theme--light.v-stepper .v-stepper__label {
    color: #009B99;
  }

  .theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {
    color: #009B99;
  }
</style>